import axios from 'axios';
import { detect } from 'detect-browser';

import {
  AddressPageValidationApi,
  ApplicationDocumentPageValidationApi,
  ApplicationInfoPageValidationApi,
  BankruptApi,
  BenefitsThirdPartyPageValidationApi,
  CallCenterApi,
  CallCenterInterbankApi,
  CallCenterIntrabankApi,
  CaptchaApi,
  CardApi,
  CardApplicationApi,
  CardObservationApi,
  CardReissueApi,
  CardSendingApi,
  CardSendingPageValidationApi,
  ClientInfoChangeApi,
  ClientInfoDocumentPageValidationApi,
  ClientInfoIndividualPageValidationApi,
  ClientInfoTaxPageValidationApi,
  ContactInfoChangeApi,
  ContactInfoChangePageValidationApi,
  ContactInfoIndividualPageValidationApi,
  ContactInfoPageValidationApi,
  CreditApi,
  CustomerApi,
  CustomerContactInfoApi,
  CustomerDetailPageValidationApi,
  CustomerLoanTaxInfoApi,
  CustomerOperationsApi,
  CustomerTaxInfoApi,
  CustomerThirdPartyApi,
  DocumentApi,
  DocumentLinkParameterApi,
  DocumentPageValidationApi,
  DocumentStorageApi,
  DocumentUploadApi,
  ExchangeRateApi,
  FiasApi,
  FnsApi,
  GlobalBonusApi,
  IndividualPageValidationApi,
  LoanDocumentApi,
  LoanPaymentPlanSimApi,
  LoanProductGlobalBonusPageValidationApi,
  LoanProductPageValidationApi,
  LoginApi,
  LogoutApi,
  NewObserveApi,
  NewSettlementApi,
  ParameterApi,
  PlasticCardApi,
  PosActivationApi,
  ProductApi,
  ProductOfferApi,
  ProductOfferPageValidationApi,
  ProductOperationsApi,
  ProductOperationsCardApplyApi,
  ProductOperationsCardApplySummaryApi,
  ProductOperationsCardApplyUpdateApi,
  ProductOperationsClientInfoChangeApi,
  ProductOperationsContactInfoChangeApi,
  ProductOperationsReissueApi,
  ProductPageValidationApi,
  PtsApi,
  ScoringApi,
  ScoringJobPageValidationApi,
  SessionApi,
  SummaryApi,
  SummaryConfirmationPageValidationApi,
  TaxInfoPageValidationApi,
  UserApi,
  ValidateLoanAddressPageApi,
  ValidateLoanContactInfoPageApi,
  ValidateLoanDocumentPageApi,
  ValidateLoanIndividualPageApi,
  ValidateLoanTaxInfoPageApi,
  ViewCreditsApi,
} from 'src/front/api/generated';
import { DEFAULT_LANGUAGE } from 'src/front/common/i18n';
import { Languages } from 'src/front/contexts/I18nContext';

const browser = detect(navigator.userAgent);

const requestHeaders = {
  'Content-Type': 'application/json',
  platform: browser?.os,
  browser: `${browser?.name}/${browser?.version}`,
  language: DEFAULT_LANGUAGE === Languages.Russian ? 'ru_RU' : 'en_US',
  Pragma: 'no-cache',
};

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: requestHeaders,
  withCredentials: true,

  // https://github.com/axios/axios/issues/472
  validateStatus: () => true,
});

export const updateHeaderConfig = (sessionID?: string, token?: string): void => {
  if (sessionID && token) {
    apiInstance.defaults.headers.sessionID = sessionID;
    apiInstance.defaults.headers.Authorization = token;
  }
};

export const updateHeaderLanguage = (language: Languages): void => {
  apiInstance.defaults.headers.language = language === Languages.Russian ? 'ru_RU' : 'en_US';
};

export const Login = new LoginApi(undefined, '', apiInstance);
export const Captcha = new CaptchaApi(undefined, '', apiInstance);
export const Logout = new LogoutApi(undefined, '', apiInstance);
export const ExchangeRate = new ExchangeRateApi(undefined, '', apiInstance);
export const Parameter = new ParameterApi(undefined, '', apiInstance);
export const Document = new DocumentApi(undefined, '', apiInstance);
export const Customer = new CustomerApi(undefined, '', apiInstance);
export const ProductOffer = new ProductOfferApi(undefined, '', apiInstance);
export const ProductOfferPageValidation = new ProductOfferPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const CustomerTaxInfo = new CustomerTaxInfoApi(undefined, '', apiInstance);
export const Card = new CardApi(undefined, '', apiInstance);
export const CardSending = new CardSendingApi(undefined, '', apiInstance);
export const Scoring = new ScoringApi(undefined, '', apiInstance);
export const ProductPageValidation = new ProductPageValidationApi(undefined, '', apiInstance);
export const IndividualPageValidation = new IndividualPageValidationApi(undefined, '', apiInstance);
export const DocumentPageValidation = new DocumentPageValidationApi(undefined, '', apiInstance);
export const ClientInfoIndividualPageValidation = new ClientInfoIndividualPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ClientInfoTaxPageValidation = new ClientInfoTaxPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ClientInfoDocumentPageValidation = new ClientInfoDocumentPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const TaxInfoPageValidation = new TaxInfoPageValidationApi(undefined, '', apiInstance);
export const CustomerDetailPageValidation = new CustomerDetailPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const BenefitsThirdPartyPageValidation = new BenefitsThirdPartyPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const AddressPageValidation = new AddressPageValidationApi(undefined, '', apiInstance);
export const CustomerContactInfo = new CustomerContactInfoApi(undefined, '', apiInstance);
export const ContactInfoPageValidation = new ContactInfoPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ContactInfoChangePageValidation = new ContactInfoChangePageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ContactInfoIndividualPageValidation = new ContactInfoIndividualPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const CustomerOperations = new CustomerOperationsApi(undefined, '', apiInstance);
export const CardApplicationValidation = new ApplicationInfoPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const CardSendingPageValidation = new CardSendingPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ScoringJobPageValidation = new ScoringJobPageValidationApi(undefined, '', apiInstance);
export const Summary = new SummaryApi(undefined, '', apiInstance);
export const DocumentStorage = new DocumentStorageApi(undefined, '', apiInstance);
export const CardApplication = new CardApplicationApi(undefined, '', apiInstance);
export const Session = new SessionApi(undefined, '', apiInstance);
export const SummaryConfirmationPageValidation = new SummaryConfirmationPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const ApplicationDocumentPageValidation = new ApplicationDocumentPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const PosActivation = new PosActivationApi(undefined, '', apiInstance);
export const CardObservation = new CardObservationApi(undefined, '', apiInstance);
export const ClientInfoChange = new ClientInfoChangeApi(undefined, '', apiInstance);
export const ContactInfoChange = new ContactInfoChangeApi(undefined, '', apiInstance);
export const DocumentUpload = new DocumentUploadApi(undefined, '', apiInstance);
export const CardReissue = new CardReissueApi(undefined, '', apiInstance);
export const Product = new ProductApi(undefined, '', apiInstance);
export const ProductOperations = new ProductOperationsApi(undefined, '', apiInstance);
export const ProductOperationsReissue = new ProductOperationsReissueApi(undefined, '', apiInstance);
export const ProductOperationsCardApply = new ProductOperationsCardApplyApi(
  undefined,
  '',
  apiInstance
);
export const ProductOperationsContactInfoChange = new ProductOperationsContactInfoChangeApi(
  undefined,
  '',
  apiInstance
);
export const ProductOperationsClientInfoChange = new ProductOperationsClientInfoChangeApi(
  undefined,
  '',
  apiInstance
);
export const ProductOperationsCardApplySummary = new ProductOperationsCardApplySummaryApi(
  undefined,
  '',
  apiInstance
);
export const ProductOperationsCardApplyUpdate = new ProductOperationsCardApplyUpdateApi(
  undefined,
  '',
  apiInstance
);
export const Settlement = new NewSettlementApi(undefined, '', apiInstance);
export const Observation = new NewObserveApi(undefined, '', apiInstance);
export const User = new UserApi(undefined, '', apiInstance);
export const CustomerThirdParty = new CustomerThirdPartyApi(undefined, '', apiInstance);
export const Credit = new CreditApi(undefined, '', apiInstance);
export const DocumentLink = new DocumentLinkParameterApi(undefined, '', apiInstance);
export const GlobalBonus = new GlobalBonusApi(undefined, '', apiInstance);
export const LoanProductPage = new LoanProductPageValidationApi(undefined, '', apiInstance);
export const LoanProductGlobalPage = new LoanProductGlobalBonusPageValidationApi(
  undefined,
  '',
  apiInstance
);
export const CallCenterInterbank = new CallCenterInterbankApi(undefined, '', apiInstance);
export const CallCenterIntrabank = new CallCenterIntrabankApi(undefined, '', apiInstance);
export const CallCenter = new CallCenterApi(undefined, '', apiInstance);
export const CreditView = new ViewCreditsApi(undefined, '', apiInstance);
export const LoanIndividualPageValidation = new ValidateLoanIndividualPageApi(
  undefined,
  '',
  apiInstance
);
export const LoanContactPageValidation = new ValidateLoanContactInfoPageApi(
  undefined,
  '',
  apiInstance
);
export const LoanDocumentPageValidation = new ValidateLoanDocumentPageApi(
  undefined,
  '',
  apiInstance
);
export const LoanAddressPageValidation = new ValidateLoanAddressPageApi(undefined, '', apiInstance);
export const LoanTaxInfoPageValidation = new ValidateLoanTaxInfoPageApi(undefined, '', apiInstance);
export const LoanDocument = new LoanDocumentApi(undefined, '', apiInstance);
export const CustomerLoanTaxInfo = new CustomerLoanTaxInfoApi(undefined, '', apiInstance);
export const Fias = new FiasApi(undefined, '', apiInstance);
export const PlasticCardRegistrationApi = new PlasticCardApi(undefined, '', apiInstance);
export const ProblemTrackingSystemApi = new PtsApi(undefined, '', apiInstance);
export const PPSimulationApi = new LoanPaymentPlanSimApi(undefined, '', apiInstance);
export const Bankrupt = new BankruptApi(undefined, '', apiInstance);
export const Fns = new FnsApi(undefined, '', apiInstance);
